import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "./store/actions/products-actions";
import { AnimatePresence } from "framer-motion";

import Home from './pages/Home';
import FAQ from './pages/FAQ';

import NotFound from './pages/NotFound';
import MainNavigation from "./layout/MainNavigation";
import Footer from "./layout/Footer";

import Collage from "./components/home/Collage";

import HomeRedirect from "./components/auth/HomeRedirect";
import { AuthProvider } from "./components/context/AuthContext";
import Curso from "./pages/Curso";
import LegalLucianaTattoo from "./components/home/Legas";
import GaleriaCuadros from "./pages/GaleriaCuadros";
import SubirCuadro from "./pages/Cuadros";





const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  // const products = useSelector((state) => state.products.products);

  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch]);


  return (
    <>
      <AuthProvider>

        {!isAdmin && <MainNavigation />}

        <AnimatePresence exitBeforeEnter >

          <Routes location={location} key={location.pathname}>

            <Route element={<HomeRedirect />}>
              {//              <Route path="/about" element={<About />} />
              }
              { //             <Route path="/games" element={<Games/>} />
              }
                            <Route path="/cuadros" element={<GaleriaCuadros />} />
                            <Route path="/subir-cuadros" element={<SubirCuadro />} />

              <Route path="/" element={<Home />} />
              <Route path="/curso" element={<Curso />} />
              <Route path="/legal" element={<LegalLucianaTattoo/>}/>
              <Route path="/tattoos" element={<Collage />} />
              <Route path="/FAQ" element={<FAQ />} />
            </Route>

            {/*       <Route element={<LoginRedirect />}>
              <Route path="/login" element={<Login />} />
            </Route>

            <Route element={<RegisterRedirect />}>
              <Route path="/register" element={<Register />} />
</Route>*/}

            {/*           <Route element={<DashboardRedirect />}>
              <Route path="admin/dashboard" element={<Dashboard />}>
                <Route path="products" element={<TheProducts />} />
                <Route path="addproduct" element={<AddProduct />} />
                <Route path="updateproducts">
                  <Route index element={<UpdateProducts />} />
                  <Route path=":productId" element={<ProductUpdate />} />
                </Route>*/}


            <Route path="*" element={<NotFound />} />

          </Routes>

        </AnimatePresence>
        {!isAdmin && <Footer />}
      </AuthProvider>
    </>
  );
}

export default App;
